module.exports = __webpack_public_path__ + "static/media/zipcodexpress_logo.a4a1cf84.png";